import { create } from 'zustand'

export default create((set) => ({
    plotNum: 0,
    addPlotNum: () => {
        set((state) => {
            return state.plotNum == 11 ? {plotNum: 0} : {plotNum: state.plotNum+1}
        }) 
    },
    subtractPlotNum: () => {
        set((state) => {
            return state.plotNum == 0 ? {plotNum: 11} : {plotNum: state.plotNum-1}
        }) 
    },
}))